import { ReactNode } from 'react';

export const EmptyOrganismMessage = ({ children }: { children?: ReactNode }) => (
  <div className="text-sm font-medium text-center text-greyCloudy">{children}</div>
);
